/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_UnpaidInputs */

const vi_tea_purchase_payment_unpaid = /** @type {(inputs: Tea_Purchase_Payment_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa thanh toán`)
};

/**

* @param {Tea_Purchase_Payment_UnpaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_unpaid = /** @type {((inputs?: Tea_Purchase_Payment_UnpaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_UnpaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_unpaid(inputs)
});